import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraEyebrow } from '../ensigns/eyebrow';
import { SpecraText } from '../ensigns/typography';
/** Standard compact heading for rails, drawers, and Assist panels. */ export function SpecraPanelHeader({ actions, subtitle, title }) {
    return /*#__PURE__*/ _jsxs("header", {
        className: "flex min-h-14 shrink-0 flex-wrap items-center gap-3 border-b border-border px-3 py-2 sm:px-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ _jsx(SpecraEyebrow, {
                        children: title
                    }),
                    subtitle ? /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block truncate",
                        size: "caption",
                        tone: "muted",
                        children: subtitle
                    }) : null
                ]
            }),
            actions ? /*#__PURE__*/ _jsx("div", {
                className: "flex max-w-full shrink-0 flex-wrap items-center gap-1",
                children: actions
            }) : null
        ]
    });
}
